import { createContext, useContext } from 'react';

import type { StaticContent } from 'shared/server/utils/DocumentSerializer';

const StaticDocumentContext = createContext<Record<string, unknown> | null>(null);

export function StaticDocumentDataProvider({
  data,
  children
}: {
  data: Record<string, unknown>;
  children: React.ReactNode;
}) {
  return <StaticDocumentContext.Provider value={data}>{children}</StaticDocumentContext.Provider>;
}

export const useStaticDocumentData = () => useContext(StaticDocumentContext);

export const useStaticContentData = (): StaticContent | null => {
  const rawDocument = useStaticDocumentData();
  if (!rawDocument) return null;
  return rawDocument.staticContent as StaticContent | null;
};
